import type { QuickNavigatorProps } from '@vista-digital/occ-ui'
import { FilmThumbnailMediaType } from '@vista-digital/occ-ui'
import type { NestedPartial } from '@vista-digital/utilities'

export const quickBookConfig: NestedPartial<QuickNavigatorProps> = {
    config: {
        sites: {
            enableSearch: false,
            displayAsModalOnMobile: false,
        },
        films: {
            enableSearch: false,
            displayAsModalOnMobile: false,
            mediaType: FilmThumbnailMediaType.Still,
        },
        showtimes: {
            displayAsModalOnMobile: false,
            enableSearch: false,
        },
        screeningDates: {
            displayAsModalOnMobile: false,
        },
        dropdownLabel: { show: false },
        headingLabel: { show: false },
    },
}
